(function iefe(w, d) {
    function openTooltip(tooltip) {
        tooltip.classList.remove('hide-element');
        // eslint-disable-next-line no-param-reassign
        tooltip.innerHTML = tooltip.getAttribute('data-text');
    }
    function closeTooltip(tooltip) {
        tooltip.classList.add('hide-element');
        // eslint-disable-next-line no-param-reassign
        tooltip.innerHTML = '';
    }

    const buttons = d.querySelectorAll('.NewsComment__button');

    buttons.forEach((button) => {
        const tooltip = button.parentElement.querySelector('.NewsComment__button-tooltip');

        button.addEventListener('click', () => {
            openTooltip(tooltip);
            const link = button.getAttribute('data-link');
            navigator.clipboard.writeText(link);
        });

        button.addEventListener('focusout', () => {
            closeTooltip(tooltip);
        });

        button.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeTooltip(tooltip);
            }
        });
    });
}(window, document));
